[
  {
    "id": "atk",
    "name": "Daño",
    "baseCost": 50,
    "costGrowth": 1.35,
    "valuePerLevel": 2,
    "maxLevel": 50
  },
  {
    "id": "hp",
    "name": "Vida",
    "baseCost": 40,
    "costGrowth": 1.35,
    "valuePerLevel": 5,
    "maxLevel": 50
  },
  {
    "id": "def",
    "name": "Defensa",
    "baseCost": 60,
    "costGrowth": 1.35,
    "valuePerLevel": 1,
    "maxLevel": 30
  }
]
